import { AnimatePresence, motion } from 'framer-motion';
import React, { FC, useEffect } from 'react'
import s from './ModalDetailArticle.module.scss'
import { IArticles } from '../../../store/types';
import parse from 'html-react-parser';

interface dataProps {
    setSelectedId: (id: string | null) => void;
    selectedId: string | null;
    data: null | IArticles
}

const ModalDetailArticle: FC<dataProps> = ({ selectedId, setSelectedId, data }) => {

    useEffect(() => {
        if (selectedId) {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = (e) => {
                setSelectedId(null)
            };
        }
        return () => {
            window.onpopstate = () => { };
        };
    }, [setSelectedId, selectedId])


    return (
        <AnimatePresence>
            {selectedId && (
                <motion.div
                    className={s.overlay}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={() => setSelectedId(null)}
                >
                    <motion.div
                        className={s.modal}
                        layoutId={selectedId}
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -50, opacity: 0 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className={s.close} onClick={() => setSelectedId(null)}>Х</button>
                        <div className={s.content}>
                            <div className={s.date}>
                                <p>Дата выпуска:</p>
                                <span>{data?.publishedAt}</span>
                            </div>
                            <h1 className={s.title}>{data?.title}</h1>
                            <div className={s.text}>{parse(data?.description ?? "")}</div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default ModalDetailArticle